//These percentile ranges were recorded from New Relic on June 15 2021. See https://issues.hubspotcentral.com/browse/CT-7383 for more context. @soduche
export const NINETY_NINETH_PERCENTILE = 178;
export const NINTIETH_PERCENTILE = 348;
export const SEVENTY_FIFTH_PERCENTILE = 500;
export const FIFTIETH_PERCENTILE = 696;
export const TWENTY_FIFTH_PERCENTILE = 984;
export const TENTH_PERCENTILE = 1392;